const accounts = {
    title: "Sélection du compte de {professional}",
    tab: "Sélection du compte"
}

export default accounts;